import { trigger, transition, style, animate } from '@angular/animations';

export const leftSlideInAnimation = trigger('leftSlideInAnimation', [
    transition(':enter', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('0.4s ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
    ])
]);
